import { EpimsBaseEntityDto } from './epim-base.dto';

export class PipelineGradeDto extends EpimsBaseEntityDto {
  PipelineGradeName: string;
  SubscriberId: string;
  SubscriptionUserId: string;
  }
